export default {"src":"/_next/static/media/question-mark.svg.40b044f6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};